import { StoreAction, XmAction } from 'store/actions';
import { Activations, Datasaver, LineCollection, LineDetail, LineDevice, LineDeviceCollection, LinePromotions, LineStatusCollection, PlanEligibility, RequestResult } from './models';
import { AccountPlanEligibility, ProfileLines } from 'store/user/models';
import { DeviceNetworkCompatibility } from './models/device-network-compatibility';
import { LineTransferCollection } from './models/line-transfer/line-transfer-collection';
import { LineTransferBySessionId } from './models/line-transfer/line-transfer-by-session-id';
import { PendingLineTransferCollection } from './models/line-transfer/pending-line-transfer-collection';
import { ChangeNotificationResult } from './models/change-notification';
import { SendPortOutPin } from './models/send-port-out-pin';
import { SendOTP } from './models/send-otp';
import { InsuranceElibility } from './models/insurance-eligibility';

export function lineCollectionReducer(state: LineCollection, action: XmAction<LineCollection>): LineCollection {
    switch (action.type) {
        case StoreAction.GET_LINE_COLLECTION:
        case StoreAction.GET_LINES_VIA_SSM_PROXY:
        case StoreAction.UPDATE_ACTIVATION_INFO:
        case StoreAction.POST_ACTIVATE_LINE:
        case StoreAction.POST_DPP_PAYMENT:
        case StoreAction.PERSIST_LINES:
        case StoreAction.UPDATE_DISPLAY_NAME:
            return action.payload;
        case StoreAction.GET_LINES_AND_ONE_ACTIVATION:
            const reducingLine: LineDetail = action.payload.lines.find((line: LineDetail) => line.id.key === action.params.line_id);

            if (reducingLine && reducingLine.activationInfo.hasApiData) {
                const stateLine: LineDetail = state.getLineByKey(action.params.line_id);

                stateLine.activationInfo = reducingLine.activationInfo;
            }

            return state;
        case StoreAction.GET_LINES_AND_ONE_ORDER_DETAIL:
            const reducingDevice: LineDevice = action.payload.lines.find((line: LineDetail) => line.id.key === action.params.line_id).devices.find((device: LineDevice) => device.id.key === action.params.device_id);

            if (reducingDevice && reducingDevice.orderDetail.hasApiData) {
                const stateLine: LineDetail = state.getLineByKey(action.params.line_id);

                stateLine.devices = stateLine.devices.map((device: LineDevice) => device.id.key === reducingDevice.id.key ? reducingDevice : device);
            }

            return state;
        case StoreAction.CLEAR_LINE_COLLECTION:
            return undefined;
        default:
            return state;
    }
}

export function planEligibilityReducer(state: PlanEligibility[] = [], action: XmAction<PlanEligibility>): PlanEligibility[] {
    let newState: PlanEligibility[];
    switch (action.type) {
        case StoreAction.GET_LINE_LEVEL_PLAN_ELIGIBILITY:
            // delete old banner if present
            newState = state.filter((item: PlanEligibility) => item.lineKey !== action.payload.lineKey);

            return [ ...newState, action.payload ];
        case StoreAction.CLEAR_LINE_LEVEL_PLAN_ELIGIBILITY:
            // if no filter then clear all
            if (!action.filters) {
                return undefined;
            }

            newState = state.filter((item: PlanEligibility) => item.lineKey !== action.filters.lineKey);

            return [ ...newState, action.payload ];
        default:
            return state;
    }
}

export function datasaverStatusReducer(state: Datasaver[] = [], action: XmAction<Datasaver>): Datasaver[] {
    let newState: Datasaver[];
    switch (action.type) {
        case StoreAction.GET_DATASAVER_STATUS:
            newState = state.filter((item: Datasaver) => item.lineKey !== action.payload.lineKey);

            return [ ...newState, action.payload ];
        default:
            return state;
    }
}

export function accountPlanEligibilityReducer(state: AccountPlanEligibility, action: XmAction<AccountPlanEligibility>): AccountPlanEligibility {
    switch (action.type) {
        case StoreAction.GET_ACCOUNT_PLAN_ELIGIBILITY:
            return action.payload;
        default:
            return state;
    }
}

export function linePromotionsReducer(state: LinePromotions[] = [], action: XmAction<LinePromotions>): LinePromotions[] {
    let newState: LinePromotions[];
    switch (action.type) {
        case StoreAction.GET_LINE_PROMOTIONS:
            newState = state.filter((item: LinePromotions) => item.lineKey !== action.payload.lineKey);

            return [ ...newState, action.payload ];
        default:
            return state;
    }
}

export function deviceNetworkCompatibilityReducer(state: DeviceNetworkCompatibility, action: XmAction<DeviceNetworkCompatibility>): DeviceNetworkCompatibility {
    switch (action.type) {
        case StoreAction.GET_DEVICE_NETWORK_COMPATIBILITY:
            return action.payload;
        default:
            return state;
    }
}

export function lineDeviceCollectionReducer(state: LineDeviceCollection[] = [], action: XmAction<LineDeviceCollection>): LineDeviceCollection[] {
    let newState: LineDeviceCollection[];
    switch (action.type) {
        case StoreAction.GET_LINE_DEVICES:
            newState = state.filter((item: LineDeviceCollection) => item.lineId !== action.payload.lineId);

            return [ ...newState, action.payload ];
        case StoreAction.CLEAR_LINE_DEVICES:
            // if no filter then clear all
            if (!action.filters) {
                return undefined;
            }

            newState = state.filter((item: LineDeviceCollection) => item.lineId !== action.filters.lineId);

            return [ ...newState, action.payload ];
        default:
            return state;
    }
}

export function requestResultReducer(state: RequestResult, action: XmAction<RequestResult>): RequestResult {
    switch (action.type) {
        case StoreAction.SAVE_REQUEST_RESULT:
        case StoreAction.CLEAR_REQUEST_RESULT:
            return action.payload;
        default:
            return state;
    }
}

export function lineTransferReducer(state: LineTransferCollection[] = [], action: XmAction<LineTransferCollection>): LineTransferCollection[] {
    let newState: LineTransferCollection[];
    switch (action.type) {
        case StoreAction.GET_LINE_TRANSFER:
            newState = state.filter((item: LineTransferCollection) => item.accountIdKey !== action.payload.accountIdKey);

            return [ ...newState, action.payload ];
        default:
            return state;
    }
}

export function lineTransferBySessionIdReducer(state: LineTransferBySessionId, action: XmAction<LineTransferBySessionId>): LineTransferBySessionId {
    switch (action.type) {
        case StoreAction.GET_LINE_TRANSFER_BY_SESSION_ID:
            return action.payload;
        default:
            return state;
    }
}

export function pendingLineTransferReducer(state: PendingLineTransferCollection, action: XmAction<PendingLineTransferCollection>): PendingLineTransferCollection {
    switch (action.type) {
        case StoreAction.GET_PENDING_LINE_TRANSFER:
            return action.payload;
        default:
            return state;
    }
}

export function changeNotificationReducer(state: ChangeNotificationResult, action: XmAction<ChangeNotificationResult>): ChangeNotificationResult {
    switch (action.type) {
        case StoreAction.POST_CHANGE_NOTIFICATION:
            return action.payload;
        default:
            return state;
    }
}

export function sendPortOutPinReducer(state: SendPortOutPin, action: XmAction<SendPortOutPin>): SendPortOutPin {
    switch (action.type) {
        case StoreAction.SEND_PORT_OUT_PIN:
            return action.payload;
        default:
            return state;
    }
}

export function sendOTPReducer(state: SendOTP, action: XmAction<SendOTP>): SendOTP {
    switch (action.type) {
        case StoreAction.SEND_OTP:
            return action.payload;
        default:
            return state;
    }
}

export function insuranceElibilityReducer(state: InsuranceElibility, action: XmAction<InsuranceElibility>): InsuranceElibility {
    switch (action.type) {
        case StoreAction.GET_INSURANCE_ELIGIBILITY:
            return action.payload;
        default:
            return state;
    }
}

export function activationsReducer(state: Activations, action: XmAction<Activations>): Activations {
    switch (action.type) {
        case StoreAction.GET_ACTIVATIONS:
            return action.payload;
        default:
            return state;
    }
}

export function profileLinesReducer(state: ProfileLines, action: XmAction<ProfileLines>): ProfileLines {
    switch (action.type) {
        case StoreAction.GET_PROFILE_LINES:
            return action.payload;
        default:
            return state;
    }
}

export function lineStatusCollectionReducer(state: LineStatusCollection, action: XmAction<LineStatusCollection>): LineStatusCollection {
    switch (action.type) {
        case StoreAction.GET_LINE_STATUS:
            return action.payload;
        default:
            return state;
    }
}
